/**
 * Мелкие настройки интерфейса — порт `:core:settings` на DataStore.
 *
 * Здесь живёт только то, что можно потерять без последствий: выбранная сортировка,
 * тема, отказ от подсказки установки. Ни одного факта о делах: они лежат в базе,
 * а `localStorage` в приватном режиме Safari бросает исключение на любом обращении —
 * поэтому каждое чтение и запись обёрнуты, и потеря настройки ничего не ломает.
 */

const PREFIX = 'yatwa.';

export function readPreference(key: string): string | null {
  try {
    return localStorage.getItem(PREFIX + key);
  } catch {
    return null;
  }
}

export function writePreference(key: string, value: string): void {
  try {
    localStorage.setItem(PREFIX + key, value);
  } catch {
    // Не запомнили — не беда: в следующий раз юрист выберет заново.
  }
}

export function removePreference(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    // Некуда удалять — значит, и не сохранилось.
  }
}

/**
 * Свои ключи, начинающиеся с [start]. Нужны уборке суточных счётчиков: их имена
 * заранее не известны — в них дата.
 *
 * Перебор `localStorage` живёт здесь, а не в телеметрии, по той же причине, что
 * и всё остальное в этом файле: единственное место, которое трогает хранилище
 * браузера, — одно, и обёрнуто оно тоже один раз.
 */
export function preferenceKeys(start: string): string[] {
  try {
    const found: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(PREFIX + start)) found.push(key.slice(PREFIX.length));
    }
    return found;
  } catch {
    return [];
  }
}

/** Значение из закрытого набора: чужое или испорченное игнорируется. */
export function readOneOf<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  const stored = readPreference(key);

  return allowed.includes(stored as T) ? (stored as T) : fallback;
}
